import { motion } from 'framer-motion';
import { useMeCore } from '../../../core/modules/me';
import { useEffect } from 'react';
import { useNavigationCore } from '../../../core/router/navigation';
import useNewNavigation from '../../../core/hooks/useNewNavigation';

function Welcome() {
  const { user, getMeUser } = useMeCore();
  const { goToReports, goToMeCourses, goToInicio } = useNavigationCore();
  const { enabled: newNavigation } = useNewNavigation();

  useEffect(() => {
    getMeUser();
  }, [getMeUser]);

  useEffect(() => {
    if (user) {
      if (user.userRole.automation) {
        goToReports();
      } else if (newNavigation) {
        goToInicio();
      } else {
        goToMeCourses();
      }
    }
  }, [goToInicio, goToMeCourses, goToReports, newNavigation, user]);

  return (
    <div className="flex flex-col flex-1 items-center justify-center p-16">
      <div className="w-full max-w-3xl text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.6 }}
          animate={{ opacity: 1, scale: 1, transition: { delay: 0.1 } }}
        >
          <div>LOADING</div>
        </motion.div>
      </div>
    </div>
  );
}

export default Welcome;
